import { OrderState } from "../../../shared/types/OrderState";
import { TargetPlatform } from "../../../shared/types/TargetPlatform";

export const UNARCHIVE_ORDER_TOOLTIP = "Click to unarchive this order";
export const ACTIVATE_AND_SELECT_TARGET_PLATFORM_TOOLTIP = "Activate the order and select a target platform to enable archiving";
export const ACTIVATE_ORDER_TOOLTIP = "Activate the order to enable archiving";
export const SELECT_TARGET_PLATFORM_TOOLTIP = "Select a target platform to enable archiving";
export const ARCHIVE_ORDER_TOOLTIP = "Archive the order";

class OrderArchiveUtils {
    isArchiveControlDisabled(state: OrderState, targetPlatform: TargetPlatform): boolean {
        return state !== OrderState.Archived &&
            (state === OrderState.Disabled || targetPlatform === TargetPlatform.None);
    }

    getArchiveControlTooltip(state: OrderState, targetPlatform: TargetPlatform): string {
        if (state === OrderState.Archived) {
            return UNARCHIVE_ORDER_TOOLTIP;
        }

        const isInactive = state === OrderState.Disabled;
        const hasNoTargetPlatform = targetPlatform === TargetPlatform.None;

        if (isInactive && hasNoTargetPlatform) {
            return ACTIVATE_AND_SELECT_TARGET_PLATFORM_TOOLTIP;
        }

        if (isInactive) {
            return ACTIVATE_ORDER_TOOLTIP;
        }

        if (hasNoTargetPlatform) {
            return SELECT_TARGET_PLATFORM_TOOLTIP;
        }

        return ARCHIVE_ORDER_TOOLTIP;
    }
}

export const orderArchiveUtils = new OrderArchiveUtils();
